import Card from 'components/Card/Card.jsx';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, DropdownButton, Grid, MenuItem, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { Sticky, StickyContainer } from 'react-sticky';
//Redux
import { bindActionCreators } from 'redux';
import ButtonSave from '../../components/ButtonSave';
import Button from '../../components/CustomButton/CustomButton';
import Loading from '../../components/Loading';
import auth from '../../libCustom/auth';
import BalanceSale from './cards/balanceSale';
import Commissions from './cards/commissions';
import Files from './cards/files';
import FilesInvoice from './cards/filesInvoice';
import ReceiptSale from './cards/receiptSale';
import ReceiptSaleAdd from './cards/receiptSaleAdd';
import SaleInformation from './cards/saleInformation';
import FlightSale from './cardsSale/flightSale';
import FlightSaleAdd from './cardsSale/flightSaleAdd';
import LodgingSale from './cardsSale/lodgingSale';
import LodgingSaleAdd from './cardsSale/lodgingSaleAdd';
import OperatorsPaymentSale from './cardsSale/operatorsPaymentSale';
import OperatorsPaymentSaleAdd from './cardsSale/operatorsPaymentSaleAdd';
import OtherServicesSale from './cardsSale/otherServicesSale';
import OtherServicesSaleAdd from './cardsSale/otherServicesSaleAdd';
import Packages from './cardsSale/packages';
import PackagesAdd from './cardsSale/packagesAdd';
import * as SalesActions from './redux/SalesActions';
import swal from 'sweetalert';
import feathers from '../../feathers';

class SalesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      openConfirm: false,
      openSuccess: false,
      openReminder: false,
    };
  }

  componentWillMount() {
    //Para seleccionar el asignado a, desde el principio y se guarde correctamente
    if (!auth.verifyLogin()) return false;

    let newQuotation = immutable.set(
      this.props.Sales,
      'assignedTo',
      auth.getCurrentUser() !== null ? auth.getCurrentUser().id : ''
    );
    newQuotation = immutable.set(newQuotation, 'loading', true);

    if (this.state.id === 'create') {
      newQuotation = immutable.set(newQuotation, 'loading', false);
    }
    this.props.setState(newQuotation);

    if (this.state.id !== 'create') this.props.findById(this.state.id);
  }

  filterOperators = (obj, index, self) => {
    return (
      index ===
      self.findIndex(function (t) {
        return t['operator'] === obj['operator'];
      })
    );
  };

  saveAsync = (type = undefined) => {
    var _this = this;

    return new Promise(async function (resolve) {
      const copyLodgings = JSON.parse(
        JSON.stringify(_this.props.Sales.lodgings)
      );

      const newLodging = copyLodgings.map((lodging) => {
        lodging.hotel =
          lodging.hotel._id !== undefined
            ? lodging.hotel._id
            : lodging.hotel.id;
        return lodging;
      });

      const saleData = _this.props.Sales;

      const extractId = (item) => {
        if (!item) return item;
        if (typeof item === 'object') {
          return item._id || item.id || item.value || item;
        }
        return item;
      };

      saleData.salesInformation.assignedTo = extractId(saleData.assignedTo);

      if (!saleData.salesInformation.clientId) {
        saleData.salesInformation.clientId = saleData.clientId;
      }
      var newSalePost = {
        quotationId: saleData.quotationId,
        salesInformation: saleData.salesInformation,
        files: saleData.files,
        flights: saleData.flights,
        otherServicesSale: saleData.otherServicesSale,
        operatorsPaymentSale: saleData.operatorsPaymentSale,
        lodging: newLodging,
        packages: saleData.packages,
        receipts: saleData.receipts,
        balance: saleData.balance,
        prefolio: saleData.prefolio,
        folio: saleData.folio,
        franchiseNumber: auth.getCurrentUser().franchise.privateId,
        franchiseId: auth.getCurrentUser().franchise.id,
        assignedTo: saleData.assignedTo,
        clientId: saleData.clientId,
        prefix: saleData.salesInformation.statusId,
        type: type !== undefined ? type : saleData.type,
        limitDate: saleData.salesInformation.limitDate,
        dateSaleNote: saleData.dateSaleNote,
        operatorsList:
          saleData.operatorsArray && saleData.operatorsArray.length > 0
            ? saleData.operatorsArray.filter(_this.filterOperators)
            : null,
      };

      let saleResult;

      if (_this.state.id === 'create') {
        saleResult = await feathers.service('sales').create(newSalePost);
      } else {
        saleResult = await feathers
          .service('sales')
          .patch(_this.state.id, newSalePost);
      }
      resolve(saleResult);
    });
  };

  saveAsyncDelete = async () => {
    const saleData = this.props.Sales;

    return await feathers.service('sales').patch(this.state.id, {
      delete: true,
      prefolio: saleData.prefolio,
      folio: saleData.folio,
      receipts: saleData.receipts,
      balance: saleData.balance,
    });
  };

  handledCompleteForm = async () => {
    var _this = this;
    if (this.formGeneral.reportValidity()) {
      var _this = this;
      _this.setState({
        loading: true,
      });

      var saved = await this.saveAsync();

      this.handleSuccess(saved);
    }
  };

  handleSuccess = (res) => {
    if (res._id !== undefined) {
      this.setState({
        openSuccess: true,
        loading: false,
        id: res._id,
      });
      this.props.history.push('/admin/sales/' + res._id);
    } else {
      alert('No se guardó correctamente');
    }
  };

  handleRedirect = (res) => {
    if (res._id !== undefined) {
      this.props.history.push('/admin/sales');
    }
  };

  handledDelete = async () => {
    if (this.formGeneral.reportValidity()) {
      let result = await swal(
        '¿Seguro que quieres cancelar la orden de venta?',
        {
          buttons: ['No', 'Si, no podrás recuperarla después'],
        }
      );
      if (result) {
        this.setState({
          loading: true,
        });

        const saved = await this.saveAsyncDelete();

        this.handleRedirect(saved);
      } else {
        this.setState({ openConfirm: false });
      }
    }
  };
  componentWillUnmount() {
    this.props.stateInit();
  }

  async componentWillReceiveProps(nextProps) {
    //Crear Folio cuando se convierte en Invoce
    if (this.props.Sales.id !== undefined) {
      if (this.props.Sales.type === 'sale') {
        if (nextProps.Sales.type === 'invoice') {
          //Hacer que se genere el folio de la nota de venta eso es guardando todo pero con el invoice type...  en el will next props del saleForm si era sales y ahora invoice hacer el patch del save async
          await this.saveAsync('invoice');
        }
      }
    }

    if (
      nextProps.Sales.flights.length !== this.props.Sales.flights.length ||
      nextProps.Sales.lodgings.length !== this.props.Sales.lodgings.length ||
      nextProps.Sales.otherServicesSale.length !==
      this.props.Sales.otherServicesSale.length ||
      nextProps.Sales.packages.length !== this.props.Sales.packages.length
    ) {
      this.handledUpdateOperators(nextProps);
    }
  }

  capitalizeFirstLetter(string) {
    return string && string[0].toUpperCase() + string.slice(1).toLowerCase();
  }

  handledUpdateOperators = async (props) => {
    if (props !== undefined) {
      let operatorsArray = [];

      const getOperatores = async ({ operator, buyprice }) => {
        if (buyprice > 0) {
          if (operator !== undefined) {
            operatorsArray.push({
              operator: operator._id,
              name: this.capitalizeFirstLetter(operator.name),
              type: this.capitalizeFirstLetter(operator.tipo),
              nationalCurrency: Number(buyprice),
            });
          } else if (operator) {
            const operatorData = await feathers
              .service('operators')
              .get(operator);
            operatorsArray.push({
              operator: operator,
              name: this.capitalizeFirstLetter(operatorData.name),
              type: this.capitalizeFirstLetter(operatorData.tipo),
              nationalCurrency: Number(buyprice),
            });
          }
        }
      };

      const getOperatoresHotels = async (item) => {
        if (item.operator._id !== undefined) {
          let totalBuyPrice = 0;

          item.rooms.map((room) => {
            room.options.map((option) => {
              totalBuyPrice =
                Number(totalBuyPrice) + Number(option.purchaseCost);
            });
          });

          operatorsArray.push({
            operator: item.operator._id,
            name: this.capitalizeFirstLetter(item.operator.name),
            type: this.capitalizeFirstLetter(item.operator.tipo),
            nationalCurrency: totalBuyPrice,
          });
        } else if (item.operator) {
          let totalBuyPrice = 0;

          item.rooms.map((room) => {
            room.options.map((option) => {
              totalBuyPrice =
                Number(totalBuyPrice) + Number(option.purchaseCost);
            });
          });

          const operatorData = await feathers
            .service('operators')
            .get(item.operator);
          operatorsArray.push({
            operator: item.operator,
            name: this.capitalizeFirstLetter(operatorData.name),
            type: this.capitalizeFirstLetter(operatorData.tipo),
            nationalCurrency: Number(item.buyprice),
          });
        }
      };

      props.Sales.flights.map(getOperatores);
      props.Sales.lodgings.map(getOperatoresHotels);
      props.Sales.otherServicesSale.map(getOperatores);
      props.Sales.packages.map(getOperatores);

      var obj = {};

      operatorsArray.map((item) => {
        let currentInformation = {};
        let filterExist = props.Sales.operatorsPaymentSale.filter((payment) => {
          return payment.operator === item.operator;
        });

        if (filterExist.length > 0) {
          currentInformation = filterExist[0];
        }

        obj[item.operator] = obj[item.operator] || [];
        obj[item.operator] = {
          concept: '',
          description: '',
          datePayment: '',
          files: [],
          list: [{}],
          ...currentInformation,
          nationalCurrency:
            Number(obj[item.operator].nationalCurrency || 0) +
            Number(item.nationalCurrency),
          operator: item.operator,
        };
      });

      const operatorArray = Object.keys(obj).map((i) => obj[i]);

      this.props.setState({
        ...props.Sales,
        operatorsPaymentSale: operatorArray,
        operatorsArray: operatorsArray,
      });
    }
  };

  onDelete = async (confirm = false) => {
    let result = await swal('¿Seguro que quieres borrar la orden de venta?', {
      buttons: ['No', 'Si, no podrás recuperarla después'],
    });

    let _this = this;
    if (result) {
      _this.props.remove(this.state.id).then(function () {
        _this.props.history.push('/admin/sales');
      });
    } else {
      _this.setState({ openConfirm: true });
    }
  };

  onPrint = async (id) => {
    await this.saveAsync();

    try {
      // this.setState({
      //   openReminder: true,
      // });

      this.linkNotes.click();
    } catch (error) {
      //console.log('existe un error!', error);
    }
  };

  onConditions = (id) => {
    try {
      this.setState({ openReminder: false });
    } catch (error) {
      //console.log('existe un error!', error);
    }
  };

  onBlur = (id, value) => { };

  render() {
    let { history, Sales } = this.props;
    let { id, openConfirm, openSuccess, openReminder } = this.state;

    const ButtonsSave = () => (
      <div>
        {Sales.id ? (
          <DropdownButton
            bsStyle="info"
            title="Opciones"
            id="dropdown-sale-options"
            style={{ marginRight: 10 }}
          >
            {Number(Sales.balance.totalReceipt) >=
              Number(Sales.balance.totalPrice) &&
              Sales.balance.totalPrice !== 0 ? (
              <MenuItem
                eventKey="1"
                onClick={() => {
                  this.onPrint(Sales.id);
                  window.open(
                    process.env.REACT_APP_URL_PUBLIC + '/sale-note/' + Sales.id,
                    '_blank'
                  );
                }}
              >
                Imprimir nota de venta
              </MenuItem>
            ) : null}

            {Number(Sales.balance.totalReceipt) >=
              Number(Sales.balance.totalPrice) &&
              Sales.balance.totalPrice !== 0 ? (
              <MenuItem
                eventKey="2"
                onClick={() => {
                  window.open(
                    process.env.REACT_APP_URL_PUBLIC +
                    '/download-sales-note/' +
                    Sales.id,
                    '_blank'
                  );
                }}
              >
                Descargar nota de venta
              </MenuItem>
            ) : null}

            <MenuItem
              eventKey="3"
              onClick={() => {
                this.onConditions(Sales.id);
                window.open(
                  process.env.REACT_APP_URL_PUBLIC + '/terms-condition/' + id,
                  '_blank'
                );
              }}
            >
              Términos y condiciones
            </MenuItem>

            <MenuItem
              eventKey="4"
              href={`${process.env.PUBLIC_URL}/documents/RECONFIRMACION_PAQUETE_NACIONAL.docx`}
              download="Reconfirmacion_Paquete_Nacional.docx"
            >
              Reconfirmación Paquete Nacional
            </MenuItem>

            <MenuItem
              eventKey="5"
              href={`${process.env.PUBLIC_URL}/documents/RECONFIRMACION_HOTEL.docx`}
              download="Reconfirmacion_Hotel.docx"
            >
              Reconfirmación Hoteles
            </MenuItem>
          </DropdownButton>
        ) : null}

        <Button
          bsStyle="primary"
          style={{ marginRight: 10 }}
          onClick={() => history.push('/admin/sales')}
        >
          Regresar
        </Button>
        {Sales.quotationId !== undefined ? (
          <Button
            bsStyle="primary"
            style={{ marginRight: 10 }}
            target="_blank"
            onClick={() =>
              window.open('#/admin/quotations/' + Sales.quotationId)
            }
          >
            Ir a Cotización
          </Button>
        ) : null}

        <ButtonSave
          onClick={this.handledCompleteForm}
          disabled={this.state.loading}
        />
      </div>
    );

    const MenuSaveBasic = () => (
      <Row>
        <Col lg={12}>
          <div
            className={'pull-right'}
            style={{
              marginBottom: 15,
            }}
          >
            <ButtonsSave />
          </div>
        </Col>
      </Row>
    );

    const MenuSaveSticky = (props) => {
      return (
        <div
          style={{
            background: '#f6f5f6',
            textAlign: 'right',
            padding: '15px 10px 15px 0px',
            borderBottom: '1px solid #e1e1e1',
          }}
        >
          <ButtonsSave />
        </div>
      );
    };
    return this.props.Sales.loading ? (
      <Loading />
    ) : (
      <StickyContainer className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, cancelar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás revertir ésta opción!
          </SweetAlert>
        )}

        {openSuccess && (
          <SweetAlert
            success
            style={{ display: 'block', marginTop: '-100px' }}
            title="Se ha guardado correctamente!"
            confirmBtnBsStyle="info"
            onConfirm={() => {
              window.location.reload();
            }}
          />
        )}

        {openReminder && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="Importante!"
            confirmBtnBsStyle="info"
            onConfirm={() => this.onConditions(Sales.id)}
            onCancel={() => this.setState({ openReminder: false })}
            confirmBtnText="Si, Imprimir!"
            cancelBtnText="Más tarde"
            showCancel
          >
            Recuerda imprimir los términos y condiciones!
          </SweetAlert>
        )}

        <Grid fluid>
          <form
            onSubmit={this.handledCompleteForm}
            ref={(ref) => {
              this.formGeneral = ref;
            }}
          >
            <Sticky>
              {({ style, isSticky }) => (
                <div style={{ ...style, zIndex: 1000 }}>
                  {isSticky ? <MenuSaveSticky /> : <MenuSaveBasic />}
                </div>
              )}
            </Sticky>
            <Row>
              <Col lg={8}>
                <Card
                  title={
                    this.state.id === 'create' ? (
                      <legend>Nueva venta</legend>
                    ) : (
                      <legend>
                        Venta <strong>{Sales.folio}</strong>
                      </legend>
                    )
                  }
                  content={
                    <div>
                      <SaleInformation currentId={this.state.id} />
                    </div>
                  }
                />
                <h4>Desglose de Venta</h4>
                <Card
                  title={<legend>Vuelos</legend>}
                  content={
                    <div>
                      <FlightSale />
                      <FlightSaleAdd
                        updateOperators={this.handledUpdateOperators}
                      />
                    </div>
                  }
                />
                <Card
                  title={<legend>Hospedaje</legend>}
                  content={
                    <div>
                      <LodgingSale />
                      <LodgingSaleAdd
                        user={auth.getCurrentUser()}
                        updateOperators={this.handledUpdateOperators}
                      />
                    </div>
                  }
                />
                <Card
                  title={<legend>Otros Servicios</legend>}
                  content={
                    <div>
                      <OtherServicesSale />
                      <OtherServicesSaleAdd
                        updateOperators={this.handledUpdateOperators}
                      />
                    </div>
                  }
                />
                <Card
                  title={<legend>Paquetes</legend>}
                  content={
                    <div>
                      <Packages />
                      <PackagesAdd
                        updateOperators={this.handledUpdateOperators}
                      />
                    </div>
                  }
                />
                <Card
                  title={<legend>Pago a operadores</legend>}
                  content={
                    <div>
                      <OperatorsPaymentSale />
                      <OperatorsPaymentSaleAdd />
                    </div>
                  }
                />
              </Col>
              <Col lg={4}>
                <Card
                  title={<legend>Saldo del Cliente</legend>}
                  content={
                    <div>
                      <BalanceSale />
                    </div>
                  }
                />

                <Card
                  title={<legend>Recibos</legend>}
                  content={
                    this.state.id === 'create' ? (
                      <div>Para agregar recibos hay que guardar primero</div>
                    ) : (
                      <div>
                        <ReceiptSale saveSales={this.handledCompleteForm} />
                        <ReceiptSaleAdd saveSales={this.handledCompleteForm} />
                      </div>
                    )
                  }
                />

                <Card
                  title={<legend>Utilidades y Comisiones</legend>}
                  content={
                    <div>
                      <Commissions />
                    </div>
                  }
                />
                <Card
                  title={<legend>Expendiente de pasajero</legend>}
                  content={
                    <div>
                      <Files />
                    </div>
                  }
                />
                <Card
                  title={<legend>Facturas</legend>}
                  content={
                    <div>
                      <FilesInvoice />
                    </div>
                  }
                />
                {(auth.can('admin') && this.state.id !== 'create') ||
                  (auth.can('matriz') && this.state.id !== 'create') ||
                  (auth.can('support') && this.state.id !== 'create') ? (
                  <Button
                    bsStyle="danger"
                    style={{ marginRight: 10 }}
                    onClick={this.handledDelete}
                    disabled={this.state.loading}
                  >
                    Cancelar
                  </Button>
                ) : null}
              </Col>
            </Row>
          </form>
        </Grid>
      </StickyContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Sales: state.Sales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(SalesActions, dispatch);
};

const SalesConnect = connect(mapStateToProps, mapDispatchToProps)(SalesForm);

export default SalesConnect;



// WEBPACK FOOTER //
// ./src/views/Sales/SalesForm.jsx